import { Action } from "redux"

import * as actions from "./actions"
import { IPendingNotifications } from "./index"

export const initialState: IPendingNotifications = {
    unreadNotificationsCounter: 0,
}

const ACTION_HANDLERS: {
    [action: string]: (
        state: IPendingNotifications,
        props: Action,
    ) => IPendingNotifications
} = {
    [actions.INITIALIZE]: (
        state,
        props: actions.Initialize,
    ): IPendingNotifications => ({
        ...state,
        ...props,
    }),

    [actions.SET_UNREAD_NOTIFICATIONS_COUNT]: (
        state,
        { unreadNotificationsCounter }: actions.SetUnreadNotificationsCounter,
    ): IPendingNotifications => ({
        ...state,
        unreadNotificationsCounter,
    }),

    [actions.INCREASE_UNREAD_NOTIFICATIONS_COUNT]: (
        state,
        { count }: actions.IncreaseUnreadNotificationsCounter,
    ): IPendingNotifications => ({
        ...state,
        unreadNotificationsCounter: state.unreadNotificationsCounter + count,
    }),
}

export default function reducer(
    state: IPendingNotifications = initialState,
    action: Action,
): IPendingNotifications {
    const handler: (
        state: IPendingNotifications,
        action: Action,
    ) => IPendingNotifications = ACTION_HANDLERS[action.type]
    return handler ? handler(state, action) : state
}
